import React from 'react';
import { Hero, Button, ContentBoxContainer, ContentBoxText, ContentBoxFigure, HeroToast, Decoline, Spacer, Testimonials, VideoPlayer } from 'components';
import { Routes } from 'utils/routes';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { useRouter } from 'next/router';
import { scrollToPageElement } from 'utils/componentsCommon';
import { TOTAL_NUMBER_OF_USERS } from '../src/constants';

export default function Home() {
    const [counterActive, setCounterActive] = React.useState(true);
    const [showVideoDialog, setShowVideoDialog] = React.useState(false);
    const toggleVideo = () => {
        setShowVideoDialog(!showVideoDialog);
    };
    const image = { url: '/static/gfx/content/penly-content-27.jpg' };
    const router = useRouter();
    return (
        <>
            <Hero full={ true } overlay={ true } figure={ image.url }>
                <section className="title">
                    <h1>
                        VI HJÆLPER DIG MED <br></br>AT FÅ MEST MULIGT <br></br>UD AF{ ' ' }
                        <span className="color-highlight">
                            DIN
                            PENSION</span>

                    </h1>

                    <Spacer />
                    <div className="frontpage-buttons">
                        <Button style={{ marginRight:'1em' }} size="large" onClick={ () => router.push(Routes.PensionCheck.Start) }>TAG ET GRATIS PENSIONSTJEK NU </Button>
                        { /* <Button color="white" size="large" onClick={ () => scrollToPageElement('#nedsparingrådgivning') }>Bestil uvildig nedsparingsrådgivning</Button> */ }
                    </div>
                </section>
                <HeroToast className="accentMode" accentColor={ 'var(--color-primary)' } style ={{ fontSize: 'large' }}>
                    <strong style={{ cursor: 'pointer' }} onClick={ () => scrollToPageElement('#nedsparingrådgivning') }>Bestil uvildig nedsparingsrådgivning</strong>
                </HeroToast>
            </Hero>

            <Spacer size="large" />

            <ContentBoxContainer className="mobileflip" id="nedsparingrådgivning">
                <ContentBoxFigure figure="/static/gfx/content/penly-content-40-hero-preview.jpg" className="background-primary"></ContentBoxFigure>

                <ContentBoxText className="background-success brtr">
                    <h4>
                        Få økonomisk tryghed i
                        seniortilværelsen
                    </h4>
                    <p>
                        Vores nedsparingsrådgivning hjælper dig med at få:
                    </p>
                    <ul >
                        <li >Flere penge udbetalt år efter år </li>
                        <li>Bedre overblik over dit pensionsbudget </li>
                        <li> Ro i maven</li>
                    </ul>
                    <Button variant='outline' noshadow={ true } style={{ width:'max-content' }}  color="white" onClick={ () => router.push(Routes.Advisory.FreePensionMeeting.Flow) }>book en gratis gennemgang nu</Button>

                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer size="large" />

            <ContentBoxContainer className="mobileflip">
                <ContentBoxText className="background-highlight quote brbl">
                    <p>
                        Før vi fik rådgivning, var vi bekymrede for, om vi havde penge nok, når vi gik på pension. Vi fandt 100.000 kr. ved at optimere udbetalingerne, men den største gevinst får vi ved at have optimeret pensionerne frem til pensionsalderen.
                        <br />
                        <br />
                        Jens B. L. Hansen
                    </p>
                    <Decoline />

                    { /* <Button variant='outline' noshadow={ true } style={{ width:'max-content', marginLeft:28, marginTop:20 }}  color="white" onClick={ () => setAutoPlay(true) }>SE FILM</Button> */ }

                </ContentBoxText>
                <ContentBoxFigure figure="/static/gfx/content/Jens-nedsparing2023.jpg" className="servicelogoinline colorWhite" onClick={ () => toggleVideo() }>
                    <div className="videoPlay">
                        <img src="/static/gfx/PlayIcon.svg" />
                        Hør Jens og Lindas historie her
                    </div>
                </ContentBoxFigure>
                { /* <ContentBoxText  className="background-highlight" style={{ padding:0 }}>
                    <VideoPlayer videoId="UyfEXOfbcZc" thumbnail={ '/static/gfx/content/Jens-nedsparing2023.jpg' } standAlone autoPlay={ autoPlay } />
                </ContentBoxText> */ }
            </ContentBoxContainer>
            { showVideoDialog && (
                <div className="modalOverlay" onClick={ () => toggleVideo() }>
                    <VideoPlayer videoId="UyfEXOfbcZc" autoPlay={ true } />
                </div>
            ) }
            <ContentBoxContainer className="single">
                <ContentBoxText className="prices-affiliates counterFrontpage">
                    <div>
                        <VisibilitySensor active={ counterActive }>
                            { ({ isVisible }) => (
                                <div className="color-primary">{ isVisible ? <CountUp start={ TOTAL_NUMBER_OF_USERS - 888 } end={ TOTAL_NUMBER_OF_USERS } duration={ 3 } useEasing onStart={ () => setCounterActive(false) } /> : 1700 }</div>
                            ) }
                        </VisibilitySensor>
                    </div>
                    <p>Penly-brugere er allerede et skridt tættere på at realisere deres drømme</p>
                </ContentBoxText>
            </ContentBoxContainer>

            <Testimonials />

            <Spacer size="medium" />

            <ContentBoxContainer className="single">
                <ContentBoxText className="prices-affiliates">
                    <h3 className="color-primary">Vi samarbejder med</h3>
                    <div>
                        <a href="https://nordnet.dk/" target="_new">
                            <img src="/static/gfx/content/affiliates/nordnet-logo.png" alt="Penly - Samarbejde med Nordnet" />
                        </a>
                        <a href="https://taenk.dk/" target="_new">
                            <img src="/static/gfx/content/affiliates/forbrugerraadet-taenk-logo.svg" alt="Penly - Samarbejde med Forbrugerrådet Tænk" />
                        </a>
                        <a href="https://fagligsenior.dk/" target="_new">
                            <img src="/static/gfx/content/affiliates/faglige-seniorer-logo.svg" alt="Penly - Samarbejde med Faglige Seniorer" />
                        </a>
                        <a href="https://moneypennyandmore.dk/" target="_new">
                            <img src="/static/gfx/content/affiliates/moneypenny-and-more-logo.png" alt="Penly - Samarbejde med Moneypenny &amp; More" />
                        </a>
                    </div>
                </ContentBoxText>
            </ContentBoxContainer>

            <VideoPlayer videoId="cqsz1TMdOGQ" thumbnail="/static/gfx/content/penly-videothumbnail-cqsz1TMdOGQ.webp" autoPlay={ false } />

            <Spacer size="large" />

            <ContentBoxContainer>
                <ContentBoxFigure className="background-highlight brtl penlyplaylogo"></ContentBoxFigure>
                <ContentBoxText className="background-primary">
                    <h3>Hvor meget skal du spare op til pension?</h3>
                    <p>Prøv Penly Play og se, hvad der skal til, for at du kan leve det liv, du drømmer om i hverdagen og i fremtiden.</p>
                    <Spacer />
                    <div className="center">
                        <Button href={ Routes.PenlyPlay.LandingPage } color="white">
                            Prøv Penly Play nu
                        </Button>
                    </div>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer size="large" />

            <ContentBoxContainer className="single">
                <ContentBoxText className="background-primary brbr">
                    <h3>Få økonomisk tryghed i hverdagen og i fremtiden med Penly</h3>
                    <p>
                        Vi bruger dine data til at berige dig med viden om din økonomi, så du er bedre rustet til at træffe de rette økonomiske valg. Vores vision er at samle alle dine tal på tværs af
                        realkredit, pension samt formue og gæld. Vi hjælper dig med at forstå regnestykket. Dermed får du mest værdi for dine egne midler, og det gør dig mere tryg ved at indgå i
                        dialogen med eksempelvis din bank.
                    </p>
                    <p>
                        Vores mission er at bidrage til FN’s verdensmål om at reducere økonomisk ulighed på tværs af alder og køn. Derfor er Penlys værktøjer tilgængelige for alle og er uafhængig af
                        banker og andre finansielle selskaber.
                    </p>
                    <p>
                        Vi gør det, fordi vi mener, at enhver har ret til at få så meget som muligt ud af deres penge. Vi kender følelsen af, at økonomi kan virke uoverskueligt eller kedeligt. Derfor
                        har vi udviklet de værktøjer, vi selv savnede til at skabe overblik over vores økonomi, så du blot kan rette blikket mod resultatet.
                    </p>
                    <p>Vi tygger os igennem alle de tørre tal og giver dig en konkret anbefaling til, hvordan du kan optimere din økonomi ved at ændre på nogle få ting.</p>
                    <p>
                        Økonomi behøver ikke at være sort snak, men vi vil gerne hjælpe dig med at få sorte tal på bundlinjen, så du kan leve det liv, du drømmer om. I dag og når du går på pension.{ ' ' }
                        <a href={ Routes.AboutPenly }>Læs mere om Penly her</a>.
                    </p>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer size="medium" />

            <ContentBoxContainer>
                <ContentBoxText>
                    <h3 className="color-primary">Penly er støttet af Innovationsfonden</h3>
                </ContentBoxText>
                <ContentBoxText>
                    <a href="https://innovationsfonden.dk/" target="_new">
                        <img src="/static/gfx/content/InnovationsfondenLogo.svg" alt="Penly - alt der relaterer sig til dine penge, er støttet af Innovationsfonden" />
                    </a>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer />
        </>
    );
}
